import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/gescon/apoios/pagamentos?status=${filtro.status}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}&classificacao=${filtro.classificacao}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/gescon/apoios/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/gescon/apoios/pagamentos/anexos/${pagamentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAprovadores(idComprometimento) {
        let url = `${api}/gescon/apoios/pagamentos/comprometimentos/${idComprometimento}/aprovadores`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexos(idComprometimento) {
        let url = `${api}/gescon/apoios/pagamentos/comprometimentos/${idComprometimento}/anexos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexo(idComprometimento, comprometimentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/gescon/apoios/pagamentos/comprometimentos/${idComprometimento}/anexos/${comprometimentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        return axiosJwt
            .get(`${api}/gescon/apoios/pagamentos/${pagamentoId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLineComprometimento(idComprometimento) {
        return axiosJwt
            .get(`${api}/gescon/apoios/pagamentos/comprometimentos/${idComprometimento}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(idComprometimento) {
        return axiosJwt
            .get(`${api}/gescon/apoios/pagamentos/comprometimentos/${idComprometimento}/historico`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    // Métodos de Nota Fiscal
    obterNotasFiscais (idPagamento) {
        const tokenData = JSON.parse(localStorage.getItem('token'))
        return axios.get(baseUrlApi + 'Pagamentos/Notas-Fiscais/' + idPagamento, 
            { headers: { 'Authorization': 'Bearer ' + tokenData.token } })
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoNotaFiscal (notaFiscal) {
        const tokenData = JSON.parse(localStorage.getItem('token'))
        
        const formData = new FormData()
        
        // Adicionar os dados da nota fiscal como JSON
        const notaFiscalData = {
            IdPagamento: notaFiscal.IdPagamento,
            Numero: notaFiscal.Numero,
            DataEmissao: notaFiscal.DataEmissao,
            Observacoes: notaFiscal.Observacoes,
            DescricaoItem: notaFiscal.DescricaoItem,
            ValorServicos: notaFiscal.ValorServicos,
            ValorDeducoes: notaFiscal.ValorDeducoes,
            ValorBaseCalculo: notaFiscal.ValorBaseCalculo,
            Aliquota: notaFiscal.Aliquota,
            ValorIss: notaFiscal.ValorIss,
            ValorLiquido: notaFiscal.ValorLiquido,
            PrestadorCnpj: notaFiscal.PrestadorCnpj,
            PrestadorRazaoSocial: notaFiscal.PrestadorRazaoSocial,
            PrestadorLogradouro: notaFiscal.PrestadorLogradouro,
            PrestadorNumero: notaFiscal.PrestadorNumero,
            PrestadorComplemento: notaFiscal.PrestadorComplemento,
            PrestadorBairro: notaFiscal.PrestadorBairro,
            PrestadorCep: notaFiscal.PrestadorCep,
            PrestadorCodigoMunicipio: notaFiscal.PrestadorCodigoMunicipio,
            PrestadorUf: notaFiscal.PrestadorUf,
            PrestadorEmail: notaFiscal.PrestadorEmail,
            TomadorCnpj: notaFiscal.TomadorCnpj,
            TomadorRazaoSocial: notaFiscal.TomadorRazaoSocial,
            TomadorLogradouro: notaFiscal.TomadorLogradouro,
            TomadorNumero: notaFiscal.TomadorNumero,
            TomadorComplemento: notaFiscal.TomadorComplemento,
            TomadorBairro: notaFiscal.TomadorBairro,
            TomadorCep: notaFiscal.TomadorCep,
            TomadorCodigoMunicipio: notaFiscal.TomadorCodigoMunicipio,
            TomadorUf: notaFiscal.TomadorUf,
            TomadorEmail: notaFiscal.TomadorEmail
        }
        
        formData.append('notaFiscal', JSON.stringify(notaFiscalData))
        
        // Adicionar o arquivo PDF se existir
        if (notaFiscal.ArquivoPdf) {
            formData.append('arquivo', notaFiscal.ArquivoPdf)
        }

        return axios.post(baseUrlApi + 'Pagamentos/Inserir-Nota-Fiscal', formData, {
            headers: { 
                'Authorization': 'Bearer ' + tokenData.token,
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            return response.data
        }).catch(error => {
            return errorHandler(error)
        })
    },

    editarPagamentoNotaFiscal (notaFiscal) {
        const tokenData = JSON.parse(localStorage.getItem('token'))
        
        const formData = new FormData()
        
        // Adicionar os dados da nota fiscal como JSON
        const notaFiscalData = {
            Id: notaFiscal.Id,
            IdPagamento: notaFiscal.IdPagamento,
            Numero: notaFiscal.Numero,
            DataEmissao: notaFiscal.DataEmissao,
            Observacoes: notaFiscal.Observacoes,
            DescricaoItem: notaFiscal.DescricaoItem,
            ValorServicos: notaFiscal.ValorServicos,
            ValorDeducoes: notaFiscal.ValorDeducoes,
            ValorBaseCalculo: notaFiscal.ValorBaseCalculo,
            Aliquota: notaFiscal.Aliquota,
            ValorIss: notaFiscal.ValorIss,
            ValorLiquido: notaFiscal.ValorLiquido,
            PrestadorCnpj: notaFiscal.PrestadorCnpj,
            PrestadorRazaoSocial: notaFiscal.PrestadorRazaoSocial,
            PrestadorLogradouro: notaFiscal.PrestadorLogradouro,
            PrestadorNumero: notaFiscal.PrestadorNumero,
            PrestadorComplemento: notaFiscal.PrestadorComplemento,
            PrestadorBairro: notaFiscal.PrestadorBairro,
            PrestadorCep: notaFiscal.PrestadorCep,
            PrestadorCodigoMunicipio: notaFiscal.PrestadorCodigoMunicipio,
            PrestadorUf: notaFiscal.PrestadorUf,
            PrestadorEmail: notaFiscal.PrestadorEmail,
            TomadorCnpj: notaFiscal.TomadorCnpj,
            TomadorRazaoSocial: notaFiscal.TomadorRazaoSocial,
            TomadorLogradouro: notaFiscal.TomadorLogradouro,
            TomadorNumero: notaFiscal.TomadorNumero,
            TomadorComplemento: notaFiscal.TomadorComplemento,
            TomadorBairro: notaFiscal.TomadorBairro,
            TomadorCep: notaFiscal.TomadorCep,
            TomadorCodigoMunicipio: notaFiscal.TomadorCodigoMunicipio,
            TomadorUf: notaFiscal.TomadorUf,
            TomadorEmail: notaFiscal.TomadorEmail
        }
        
        formData.append('notaFiscal', JSON.stringify(notaFiscalData))
        
        // Adicionar o arquivo PDF se existir
        if (notaFiscal.ArquivoPdf) {
            formData.append('arquivo', notaFiscal.ArquivoPdf)
        }

        return axios.put(baseUrlApi + 'Pagamentos/Atualizar-Nota-Fiscal', formData, {
            headers: { 
                'Authorization': 'Bearer ' + tokenData.token,
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            return response.data
        }).catch(error => {
            return errorHandler(error)
        })
    },

    excluirNotaFiscal (id) {
        const tokenData = JSON.parse(localStorage.getItem('token'))
        return axios.delete(baseUrlApi + 'Pagamentos/Excluir-Nota-Fiscal/' + id, 
            { headers: { 'Authorization': 'Bearer ' + tokenData.token } })
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    downloadNotaFiscal (id) {
        const tokenData = JSON.parse(localStorage.getItem('token'))
        return axios.get(baseUrlApi + 'Pagamentos/Download-Nota-Fiscal/' + id, {
            headers: { 'Authorization': 'Bearer ' + tokenData.token },
            responseType: 'blob'
        })
        .then(response => {
            return response.data
        }).catch(error => {
            return errorHandler(error)
        })
    },

    obterMunicipios (uf) {
        const tokenData = JSON.parse(localStorage.getItem('token'))
        return axios.get(baseUrlApi + 'v1/pagamentos/municipios/' + uf, 
            { headers: { 'Authorization': 'Bearer ' + tokenData.token } })
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }
}
